import {
  SUBSTEP_TYPE,
  isDisclosureRadioItems,
} from "utils/constants/onboarding";
import {
  buildPrimitiveValueByKey,
  getSelectedDisclosureItem,
  hasTodoPrimitives,
} from "./substeps/todoListUtils";
import {
  isSubstepFilled,
  isSubstepOptional,
} from "./fieldRules";

export { isSubstepFilled, isSubstepOptional } from "./fieldRules";

const fieldLabel = (substep) =>
  substep?.title || substep?.key || `field #${substep?.substep_id}`;

const missingForDisclosureTodo = (substep, draftValues, valueByKey) => {
  const selectedItem = getSelectedDisclosureItem(substep.input_todo_list?.items ?? [], draftValues);
  if (!selectedItem) return [fieldLabel(substep)];

  return (selectedItem.primitive_inputs ?? [])
    .filter((prim) => !isSubstepFilled(prim, draftValues, valueByKey))
    .map(fieldLabel);
};

const missingForFormGroupTodo = (substep, draftValues, valueByKey) => {
  const missing = [];
  const items = substep.input_todo_list?.items ?? [];
  const primitiveValueByKey = buildPrimitiveValueByKey(items, draftValues);
  const combinedValueByKey = { ...valueByKey, ...primitiveValueByKey };
  const gstIsNa = (primitiveValueByKey.gst_number_input ?? "").toUpperCase() === "NA";

  for (const item of items) {
    for (const prim of item.primitive_inputs ?? []) {
      if (prim.key === "gst_certificate_upload" && gstIsNa) continue;
      if (!isSubstepFilled(prim, draftValues, combinedValueByKey)) {
        missing.push(fieldLabel(prim));
      }
    }
  }
  return missing;
};

const missingForTodo = (substep, draftValues, valueByKey) => {
  const items = substep.input_todo_list?.items ?? [];
  if (!items.length || !hasTodoPrimitives(items)) {
    return isSubstepFilled(substep, draftValues, valueByKey) ? [] : [fieldLabel(substep)];
  }
  if (isDisclosureRadioItems(items)) {
    return missingForDisclosureTodo(substep, draftValues, valueByKey);
  }
  return missingForFormGroupTodo(substep, draftValues, valueByKey);
};

// Returns display labels for active-step fields still blocking Continue.
export const missingRequiredFields = (step, draftValues, valueByKey) => {
  const missing = [];
  for (const substep of step?.substeps ?? []) {
    if (substep.substep_type === SUBSTEP_TYPE.TODO_LIST) {
      missing.push(...missingForTodo(substep, draftValues, valueByKey));
    } else if (!isSubstepFilled(substep, draftValues, valueByKey)) {
      missing.push(fieldLabel(substep));
    }
  }
  return missing;
};

// Builds a flat key→value map from all substep string values across all steps.
// Used for cross-field rules (e.g. ownership type → CIN required).
export const getPrimitiveValueByKey = (steps, draftValues) => {
  const map = {};
  const visitSubstep = (substep) => {
    if (!substep) return;
    if (substep.key) map[substep.key] = (draftValues[substep.substep_id]?.string_value ?? "").trim();
    for (const item of substep.input_todo_list?.items ?? []) {
      if (item.key) map[item.key] = (draftValues[item.substep_id]?.string_value ?? "").trim();
      for (const prim of item.primitive_inputs ?? []) visitSubstep(prim);
    }
  };
  for (const step of steps ?? []) {
    for (const substep of step?.substeps ?? []) visitSubstep(substep);
  }
  return map;
};
